class ReadMore extends HTMLElement {
  constructor() {
    super();
    
    this.readMoreButton = this.querySelector('.js-read-more');
    this.readLessButton = this.querySelector('.js-read-less');
    this.descriptionFull = this.querySelector('.js-description-full');
    this.descriptionShort = this.querySelector('.js-description-short');
    this.readMoreButton.addEventListener('click', this.open.bind(this));
    this.readLessButton.addEventListener('click', this.close.bind(this))
  }
  open() {
    this.descriptionFull.style.display = 'block';
    this.descriptionShort.style.display = 'none';
  }
  close() {
    this.descriptionFull.style.display = 'none';
    this.descriptionShort.style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('read-more', ReadMore);